module.exports = __webpack_public_path__ + "static/media/stars.e51af4c2.svg";